import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useState, useEffect } from 'react';
import Layout from "./Layout";
import Home from "./Home";
import AboutUs from "./AboutUs";
import NoPage from "./NoPage";
import PublicarPage from "./PublicarPage";
import MisPublicacionesPage from "./MisPublicacionesPage";
import AdminPage from "./AdminPage";
import VehicleDetailPage from "./VehicleDetailPage";
import marcaService from "../services/marcaService";

export default function Main() {

  const SEARCH_URI = 'https://18.223.151.149:8001/soloautos/brands';

  const [filterData, setFilterData] = useState({
    "brands": [],
    "hashtags": [],
  });

  // eslint-disable-next-line
  const fetchData = async () => {
    try {
      const makers = await marcaService.getMakers();
      setFilterData({ brands: makers, hashtags: [] });
    } catch (err) {
      console.error('Error al cargar marcas', err);
    }
  }

  const dummyFetchData = () => {
    setTimeout(() => {
      setFilterData(
        {
          "brands": [{ "name": "Mazda", "image_url": "https://logowik.com/content/uploads/images/mazda-3d-black4958.jpg" }, { "name": "Fiat", "image_url": "https://logowik.com/content/uploads/images/mazda-3d-black4958.jpg" }, { "name": "Chevrolet", "image_url": "https://logowik.com/content/uploads/images/mazda-3d-black4958.jpg" }, { "name": "Ford", "image_url": "https://logowik.com/content/uploads/images/mazda-3d-black4958.jpg" }, { "name": "Mercedes Benz", "image_url": "https://logowik.com/content/uploads/images/mazda-3d-black4958.jpg" }, { "name": "BMW", "image_url": "https://logowik.com/content/uploads/images/mazda-3d-black4958.jpg" }, { "name": "Chery", "image_url": "https://logowik.com/content/uploads/images/mazda-3d-black4958.jpg" }, { "name": "Nissan", "image_url": "https://logowik.com/content/uploads/images/mazda-3d-black4958.jpg" }],
          "hashtags": [1, 1, 1],
        }
      )
    }, 1000);
  }

  // To make your useEffect run only once, pass an empty array [] as the second argument, as seen in the revised snippet below.
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout filterData={filterData} />}>
          <Route index element={<Home filterData={filterData} />} />
          <Route path="acerca" element={<AboutUs />} />
          <Route path="publicar" element={<PublicarPage />} />
          <Route path="mis-publicaciones" element={<MisPublicacionesPage />} />
          <Route path="admin" element={<AdminPage />} />
          <Route path="vehiculo/:slug" element={<VehicleDetailPage />} />
          <Route path="*" element={<NoPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}